module.exports = __webpack_public_path__ + "img/197.249a62df.png";